<!-- SamplesTable.vue -->
<template>
  <section>
    <!-- Filtros -->
    <b-field grouped group-multiline>
      <b-field label="Buscar Muestra">
        <b-input
          v-model="query"
          @input="handleQueryInput"
          placeholder="Ej. 1024 o ABC-123"
          icon="search"
          clearable
        />
      </b-field>
    </b-field>

    <div class="responsive-table mt-5">
      <!-- Tabla -->
      <b-table
        :data="rows"
        :loading="loading"
        :paginated="true"
        :backend-pagination="true"
        :total="total"
        :per-page="perPage"
        :current-page.sync="page"
        :striped="true"
        :hoverable="true"
        :mobile-cards="true"
        @page-change="onPageChange"
      >
        <b-table-column field="id" label="id" width="90" v-slot="props">
          {{ props.row.id }}
        </b-table-column>

        <b-table-column field="sample_code" label="No Muestra" v-slot="props">
          {{ props.row.sample_code }}
        </b-table-column>

        <b-table-column field="created_at" label="Fecha creación" v-slot="props">
          {{ formatDate(props.row.created_at, true) }}
        </b-table-column>

        <b-table-column field="updated_at" label="Ultima actualización" v-slot="props">
          {{ formatDate(props.row.updated_at, true) }}
        </b-table-column>

        <b-table-column field="actions" label="actions" width="90" v-slot="props">
          <router-link :to="{name: 'eden-show', params: { sampleCode: props.row.id }}">
            <b-button
              size="is-small"
              type="is-info"
              icon-left="eye"
              outlined
            >
            </b-button>
          </router-link>
        </b-table-column>

        <template #empty>
          <section class="section has-text-centered">
            <p>No hay datos que coincidan con los filtros.</p>
          </section>
        </template>
      </b-table>
    </div>
  </section>
</template>

<script>
import debounce from 'lodash/debounce';
export default {
  name: "SamplesTable",
  data() {
    return {
      query: "",
      page: 1,
      perPage: 10,
      total: 0,
      rows: [],
      loading: false,
      _debounceId: null
    };
  },
  computed: {},
  mounted() {
    this.wrapper = document.getElementById("main-wrapper");
    this.wrapper.classList.add("is-expanded");
    this.fetchData();
  },
  methods: {
    resetFilters() {
      this.query = "";
    },
    formatDate(value, withTime = false) {
      if (!value) return "—";
      const d = new Date(value);
      if (Number.isNaN(d.getTime())) return String(value);
      const pad = (n) => (n < 10 ? "0" + n : n);
      const yyyy = d.getFullYear();
      const mm = pad(d.getMonth() + 1);
      const dd = pad(d.getDate());
      if (!withTime) return `${yyyy}-${mm}-${dd}`;
      const hh = pad(d.getHours());
      const mi = pad(d.getMinutes());
      return `${yyyy}-${mm}-${dd} ${hh}:${mi}`;
    },
    startOfDay(dateObj) {
      const d = new Date(dateObj);
      d.setHours(0, 0, 0, 0);
      return d;
    },
    endOfDay(dateObj) {
      const d = new Date(dateObj);
      d.setHours(23, 59, 59, 999);
      return d;
    },
    runFetchData() {
      console.log("Fetching data...");
      this.loading = true;
      this.$http.get("imaging/samples", {
        params: {
          page: this.page,
          query: this.query,
          per_page: this.perPage
        }
      }).then(({ data }) => {
        this.rows = data.data;
        this.total = data.meta.total;
      }).catch(error => {
        this.$alfalab.showError(error);
      }).finally(() => {
        this.loading = false;
      });
    },
    fetchData: debounce(function(){
      this.runFetchData()
    }, 500),
    handleQueryInput(){
      this.page = 1;
      this.fetchData();
    },
    onPageChange(){
      this.fetchData();
    }
  }
};
</script>
